<template>
    <div class="account">
        <div class="container">
            <ui-header heading="Account" />
            <div class="account-body">
                <div class="row">
                    <div class="col-md-5">
                        <account-emails />
                    </div>
                    <div class="col-md-7">
                        <account-payment v-if="payment" :payment="payment" />
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-md-5">
                        <account-payment-plan v-if="payment" />
                    </div>
                    <div class="col-md-7">
                        <account-invoices v-if="payment" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UiHeader from "../ui-kit/ui-header.vue";

import AccountPayment from "./account-payment.vue";
import AccountEmails from "./account-emails.vue";
import AccountInvoices from "./account-invoices.vue";
import AccountPaymentPlan from "./account-payment-plan.vue";

export default {
    name: "account-root",
    props: {
        stripeKey: {
            type: String,
            required: true,
        },
        intentKey: {
            type: String,
            required: true,
        },
    },
    components: {
        UiHeader,
        AccountEmails,
        AccountPayment,
        AccountInvoices,
        AccountPaymentPlan,
    },
    created() {
        this.$store.dispatch("fetchAccount");
        this.$store.dispatch("fetchPaymentPlan");
        this.$store.commit("setPaymentUser", this.intentKey);
        this.$store.commit("setPaymentClient", this.stripeKey);
    },
    computed: {
        payment: function () {
            const account = this.$store.getters.account;
            if (
                account &&
                account.payment_method &&
                !Array.isArray(account.payment_method)
            ) {
                return account.payment_method;
            }
            return false;
        },
    },
};
</script>

<style lang="scss">
.account {
    padding: 80px 0;
}
.account-body {
    position: relative;
}

.account-label {
    margin-bottom: 0.5rem;
    font-size: 14px;
}
</style>
